import reducers from './reducers'

export { default as industriesTypes } from './types'
export { default as industriesActions } from './actions'
export { default as industriesSelectors } from './selectors'
export { default as industriesEpics } from './epics'

export default reducers
